export const userPic: string = "https://picsum.photos/200"

export const productPic: string = "https://placeimg.com/640/480/any?r=0.591926261873231"

export const categoryPic: string = "https://placeimg.com/640/480/any"

export const productImages: string[] = [
    "https://placeimg.com/640/480/any?r=0.9178516507833767",
    "https://placeimg.com/640/480/any?r=0.9300320592588625",
    "https://placeimg.com/640/480/any?r=0.8807778235430017"
]